module.exports = __webpack_public_path__ + "static/media/notConnected.f2b5adfc.svg";